import { useIntl } from "react-intl";

import { PaymentDetailsSummaryRow } from "@/components/PaymentDetails/PaymentDetailsSummaryRow";
import { calculateMonthlyInstallment, includeBnplFee } from "@/utils/bnpl-fee";
import { formatCurrency } from "@/utils/currency";

type Props = {
  totalPrice: number;
  selectedInstallments: number;
};

export const PaymentDetailsMonthlyPaymentRow = ({
  totalPrice,
  selectedInstallments,
}: Props) => {
  const intl = useIntl();

  return (
    <PaymentDetailsSummaryRow
      label={intl.formatMessage({
        defaultMessage: "Monthly payment",
        description: "Label for the monthly payment amount",
      })}
      value={formatCurrency(
        calculateMonthlyInstallment(
          includeBnplFee(totalPrice),
          selectedInstallments,
        ),
      )}
    />
  );
};
